export default {
  MY_CHATS: 'MY_CHATS',
  LIST_CONTACTS: 'LIST_CONTACTS',
  NEW_CHAT: 'NEW_CHAT',
  EDIT_CHAT: 'EDIT_CHAT',
  LIST_CONTACTS_TO_GROUP: 'LIST_CONTACTS_TO_GROUP',
  CHAT_DETAILS: 'CHAT_DETAILS',
};
